import { useMemo, useState } from "react"

import { DataFetchWrapper } from "~/components/DataFetchWrapper"
import { StandardMapping } from "~/pages/Admin/Mapping/Standards/StandardsMapping"
import { useFindMappingByTypeQuery } from "~/pages/Admin/Mapping/hooks/useFindMappingByTypeQuery"
import {
  DEFAULT_PAGE_SIZE,
  MappingCollapseProps,
  MappingTypeNames,
} from "~/pages/Admin/Mapping/types"

type StandardMappingWrapperProps = MappingCollapseProps

export const StandardMappingWrapper = ({
  isOpen,
  close,
  open,
}: StandardMappingWrapperProps) => {
  const [page, setPage] = useState(1)
  const [search, setSearch] = useState<string>("")
  const query = useFindMappingByTypeQuery(MappingTypeNames.STANDARD, {
    page,
    search,
  })

  const totalPages = useMemo<number>(
    () =>
      query.data?.data.total
        ? Math.ceil(query.data.data.total / DEFAULT_PAGE_SIZE)
        : 0,
    [query.data?.data.total]
  )

  return (
    <DataFetchWrapper query={query} acceptEmpty>
      {({ data }) => (
        <StandardMapping
          standards={data.data.mappings}
          pagination={{
            totalPages,
            currentPage: page,
            onPageChange: setPage,
          }}
          search={search}
          setSearch={setSearch}
          isOpen={isOpen}
          close={close}
          open={open}
        />
      )}
    </DataFetchWrapper>
  )
}
